import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export enum VehiclePlanningStatusEnum {
  YOLDA = 'YOLDA',
  SIRADA = 'SIRADA',
  ICERIDE = 'ICERIDE',
  AKTARMA = 'AKTARMA',
  DEDIKE = 'DEDIKE',
  TAMAMLANMIS = 'TAMAMLANMIS',
  TRANSFER = 'TRANSFER'
}

export class IVehiclePlan {
  id: string;
  creatorId: number;
  updatedAt: string;
  description: string;
  companyId: number[];
  regionId: number;
  type: string;
  typeCompany: string;
  route?: number;
  routes?: number[];
  vehicleId: number;
  driverName: string;
  driverPhone: string;
  operationType: string;
  price: number;
  status: number;
  createdAt: string;
  priceAdds: {
    type: string;
    value: number;
  }[];
  spin: number;
  workday: number;
  latestStatus: VehiclePlanningStatusEnum;
  vehicleStatus: {
    type: string;
    date?: string;
  }[];
  isVehicleTransfer?: boolean;
  cancellationFee?: number;
  priceFtl?: number;
}

export class IVehiclePlanResponse {
  @Type(() => IVehiclePlan)
  result: IVehiclePlan;
}

export class IVehliclePlanListResponse extends IPagination {
  @Type(() => IVehiclePlan)
  results: IVehiclePlan[];
}

export class IVehiclePlanQueryDto extends IQueryPaginationDto {
  id?: string;
  companyId?: string;
  regionId?: number;
  type?: string;
  typeCompany?: string;
  vehicleId?: number;
  driverName?: string;
  driverPhone?: string;
  operationType?: string;
  price?: number;
  status?: number;
  priceAdds?: number;
  spin?: number;
  startDate?: string;
  endDate?: string;
  workday?: number;
  latestStatus?: VehiclePlanningStatusEnum;
}

export class IVehiclePlanPatchBodyDto {
  description?: string;
  companyId?: number[];
  regionId?: number;
  type?: string;
  typeCompany?: string;
  vehicleId?: number;
  driverName?: string;
  driverPhone?: string;
  operationType?: string;
  price?: number;
  status?: number;
  route?: number;
  routes?: number[];
  priceAdds?:
    | {
        type: string;
        value: number;
      }[]
    | null;
  spin?: number;
  workday?: number;
  vehicleStatus?: {
    type: string;
  }[];
  isVehicleTransfer?: boolean;
  cancellationFee?: number | null;
  priceFtl?: number | null;
}

export class IPostVehiclePlanBodyDto {
  creatorId: number;
  description: string;
  companyId: number[];
  regionId: number;
  type: string;
  typeCompany: string;
  vehicleId: number;
  driverName: string;
  driverPhone: string;
  route?: number;
  routes?: number[];
  operationType: string;
  price: number;
  status: number;
  priceAdds?:
    | {
        type: string;
        value: number;
      }[]
    | null;
  spin: number;
  workday: number;
  vehicleStatus: {
    type: string;
  }[];
  isVehicleTransfer: boolean;
  cancellationFee?: number | null;
  priceFtl?: number | null;
}

export class IVehiclePlanVehicleStatusPostBodyDto {
  type: VehiclePlanningStatusEnum;
}
